// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3_6Om","left":"InfoRow_left__3DLmd"};